import React from "react";
import { motion } from "framer-motion";
import { Stethoscope } from "lucide-react";
import { SectionLabel } from "./SectionLabel";
import { CARE_TEAM, fadeUp, stagger } from "./constants";

export default function EliteCareTeam() {
  return (
    <section className="py-24 md:py-28 bg-[#0D1F17] relative" data-testid="care-team">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div {...fadeUp} className="text-center mb-16">
          <SectionLabel light>Your Care Team</SectionLabel>
          <h2 className="font-serif text-3xl sm:text-4xl text-[#F7F5F0] mt-4">
            You're not just getting a diet plan
          </h2>
          <p className="text-[#A3B8AD] mt-3 text-sm max-w-lg mx-auto">
            Specialists are brought in as each client's case requires — not every client sees every specialist.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARE_TEAM.map((member, i) => (
            <motion.div key={member.name} {...stagger(i)} data-testid={`team-member-${i}`}
              className={`p-6 rounded-xl border transition-all ${
                member.highlight
                  ? "bg-[#D4AF37]/5 border-[#D4AF37]/20"
                  : "bg-[#132A20]/60 border-[#F7F5F0]/5 hover:border-[#F7F5F0]/10"
              }`}>
              <div className="w-11 h-11 rounded-full bg-[#F7F5F0]/5 border border-[#F7F5F0]/10 flex items-center justify-center mb-4">
                <Stethoscope size={18} className={member.highlight ? "text-[#D4AF37]" : "text-[#A3B8AD]"} />
              </div>
              <h4 className="font-serif text-base text-[#F7F5F0]">{member.name}</h4>
              <p className="text-xs text-[#A3B8AD] mt-1 leading-relaxed">{member.role}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
